// extracted by mini-css-extract-plugin
export var breadcrumb = "_1o-0";
export var breadcrumbArrow = "_1o-1";